import { render, staticRenderFns } from "./payment-notice.vue?vue&type=template&id=a21a2c66&scoped=true"
import script from "./payment-notice.vue?vue&type=script&lang=js"
export * from "./payment-notice.vue?vue&type=script&lang=js"
import style0 from "./payment-notice.vue?vue&type=style&index=0&id=a21a2c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21a2c66",
  null
  
)

export default component.exports